// The customer's sites as a FLAT hairline-divided row-list (Session ACG Linear pattern; extracted
// Session AFH so the dashboard "Your sites" section and the top-level Sites page share ONE
// implementation, keeping the flat-row treatment in a single place). ONE outer hairline container,
// rows divided by hairlines only (no per-row card, no accent stripe -- the coloured left-border
// pattern is banned app-wide). The status dot is the only colour on a row; hover is a quiet
// background wash and the trailing arrow brightening to green.
import { Link } from "react-router-dom";
import type { PortalSite } from "../../lib/api";
import { StatusDot } from "./PortalLiftCard";

export function PortalSiteList({ sites }: { sites: PortalSite[] }) {
  if (sites.length === 0) {
    return (
      <p className="rounded-ele border border-white/10 bg-[rgba(255,255,255,0.04)] p-4 text-sm text-ele-body">No sites are on your account yet.</p>
    );
  }
  return (
    <ul className="overflow-hidden rounded-ele border border-white/10 bg-[rgba(255,255,255,0.04)]">
      {sites.map((site) => (
        <li key={site.id} className="border-b border-white/10 last:border-0">
          <Link
            to={`/portal/sites/${site.id}`}
            className="group flex flex-wrap items-center justify-between gap-3 px-4 py-4 transition hover:bg-[rgba(255,255,255,0.03)]"
          >
            <div className="flex items-center gap-3">
              <StatusDot status={site.worstStatus} />
              <div>
                <p className="font-heading text-lg text-ele-white">{site.name}</p>
                {site.address && <p className="text-sm text-ele-body">{site.address}</p>}
              </div>
            </div>
            <span className="flex items-center gap-3 text-sm text-ele-body">
              {site.liftCount} {site.liftCount === 1 ? "lift" : "lifts"}
              {(site.equipmentCount ?? 0) > 0 &&
                ` · ${site.equipmentCount} equipment ${site.equipmentCount === 1 ? "item" : "items"}`}
              <span aria-hidden className="text-[#8a8a8a] transition group-hover:text-ele-green">
                &#8594;
              </span>
            </span>
          </Link>
        </li>
      ))}
    </ul>
  );
}
